import { faPrintSlash } from "@fortawesome/pro-light-svg-icons";

import { T } from "@repo/transifex";

import { Modal } from "../../shared/modal";
import { ModalButton } from "../../shared/modal-button";
import { ModalButtonGroup } from "../../shared/modal-button-group";
import { ModalIcon } from "../../shared/modal-icon";
import { ModalTitle } from "../../shared/modal-title";

type ModalPrintingErrorProps = {
  onRetry: () => void;
  onClose: () => void;
};

export const ModalPrintingError = ({
  onRetry,
  onClose
}: ModalPrintingErrorProps) => {
  return (
    <Modal backdropVariant="error">
      <div className="flex flex-col items-center gap-y-16">
        <ModalIcon icon={faPrintSlash} variant="error" />

        <ModalTitle size="8xl" variant="error" weight="black">
          <T _str="Printing failed" />
        </ModalTitle>

        <p className="text-5xl font-extralight text-kiosk-background-primary">
          <T _str="Please try again or contact staff" />
        </p>

        <ModalButtonGroup direction="vertical">
          <ModalButton onClick={onRetry} variant="error" size="medium">
            <T _str="Try again" />
          </ModalButton>

          <ModalButton onClick={onClose} variant="transparent" size="medium">
            <T _str="Cancel" />
          </ModalButton>
        </ModalButtonGroup>
      </div>
    </Modal>
  );
};
